/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetIntegrationEnabled200Response
 */
export interface SetIntegrationEnabled200Response {
    /**
     * 
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the SetIntegrationEnabled200Response interface.
 */
export function instanceOfSetIntegrationEnabled200Response(value: object): value is SetIntegrationEnabled200Response {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function SetIntegrationEnabled200ResponseFromJSON(json: any): SetIntegrationEnabled200Response {
    return SetIntegrationEnabled200ResponseFromJSONTyped(json, false);
}

export function SetIntegrationEnabled200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetIntegrationEnabled200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function SetIntegrationEnabled200ResponseToJSON(json: any): SetIntegrationEnabled200Response {
    return SetIntegrationEnabled200ResponseToJSONTyped(json, false);
}

export function SetIntegrationEnabled200ResponseToJSONTyped(value?: SetIntegrationEnabled200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

